import styled from 'styled-components';
import { LinkButton } from 'src/components/Button/LinkButton';
const baseFontSize = 16;

export const StyledCollapsableList = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  .contracts {
    width: 100%;
    line-height: 100%;
    margin: 0;
    padding: 0;
    list-style: none;
  }

  .options-section {
    margin-top: 8px;
    
    .options-btn {
      font-style: normal;
      font-weight: 400;
      font-size: 0.9375em;
      text-align: right;
      text-decoration-line: underline;
    }
  }
`;

export const SeeMoreButton = styled(LinkButton)`
  font-style: normal;
  font-weight: 400;
  font-size: ${baseFontSize}px;
  text-align: right;
  line-height: 1.5em;
  text-decoration: underline;
`;

export const SeeLessButton = styled(LinkButton)`
  font-style: normal;
  font-weight: 400;
  font-size: ${baseFontSize}px;
  text-align: right;
  line-height: 1.5em;
  text-decoration: underline;
`;
